import React from 'react';

import moment from 'moment';

import LoadingSpinner from 'CommonComponents/LoadingSpinner';
import Modal from 'CommonComponents/Modal';
import ModalHeader from 'CommonComponents/ModalHeader';

export default function ProjectActivityActionsModal(props) {
    const close = () => {
        props.modal.hide();
    };

    return (
        <Modal id={props.id} modal={props.modal}>
            <ModalHeader dark close={close}>
                <div>
                    <div>{$t('Actions')}</div>
                    <div className="tw-text-base tw-text-charcoal-50 tw-font-medium">{props.activity?.description}</div>
                </div>
            </ModalHeader>
            <div className="tw-rounded-b">
                {props.isLoading ? (
                    <LoadingSpinner />
                ) : (
                    <div>
                        <div className="inbud-table_wrapper tw-overflow-y-auto tw-max-h-60">
                            <table className="inbud-table tw-table-fixed">
                                <thead className="tw-sticky tw-top-0 tw-z-10">
                                    <tr>
                                        <th>{$t('Name')}</th>
                                        <th className="tw-w-32">{$t('Owner')}</th>
                                        <th className="tw-w-28">{$t('Start Date')}</th>
                                        <th className="tw-w-28">{$t('Due Date')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {props.actions?.map((action) => (
                                        <tr key={action.id}>
                                            <td>{action.description}</td>
                                            <td>{action.owner && `${action.owner.first_name} ${action.owner.last_name}`}</td>
                                            <td>{moment(action.date).format('DD/MM/YYYY')}</td>
                                            <td>{moment(action.completed_date).format('DD/MM/YYYY')}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            </div>
        </Modal>
    );
}
